import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getDetailItemSuccess,
  getDetailItemFailed,
  GET_DETAIL_ITEM_START,
} from '../../actions/item'

/**
 * get detail item
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getDetailItemApi = (props) => {
  var uri = `./items/${props?._id}`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetDetailItem(action) {
  try {
    const response = yield call(getDetailItemApi, action?.payload)
    yield put(getDetailItemSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getDetailItemFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get detail item
 */
export default function* watchGetDetailItem() {
  yield takeLatest(GET_DETAIL_ITEM_START, doGetDetailItem)
}
